(() => {
  const root = document.documentElement;
  const motionEnabled =
    root.dataset.ccMotion !== 'false' &&
    window.matchMedia('(prefers-reduced-motion: no-preference)').matches;

  const reveal = () => {
    const nodes = document.querySelectorAll('[data-cc-reveal]:not(.is-in)');
    if (!nodes.length) return;

    if (!motionEnabled || !('IntersectionObserver' in window)) {
      nodes.forEach((el) => el.classList.add('is-in'));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.14, rootMargin: '0px 0px -8% 0px' }
    );

    nodes.forEach((el) => io.observe(el));
  };

  const heroStage = () => {
    document.querySelectorAll('[data-cc-hero]').forEach((hero) => {
      hero.classList.add('is-ready');
    });
  };

  const parallax = () => {
    const layers = document.querySelectorAll('[data-cc-parallax]');
    if (!layers.length || !motionEnabled) return;
    if (window.matchMedia('(max-width: 989px)').matches) return;
    if (navigator.connection && navigator.connection.saveData) return;

    let ticking = false;
    const update = () => {
      layers.forEach((el) => {
        const rect = el.getBoundingClientRect();
        const offset = (rect.top - window.innerHeight * 0.35) * -0.08;
        el.style.transform = `translate3d(0, ${offset.toFixed(2)}px, 0)`;
      });
      ticking = false;
    };

    window.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      },
      { passive: true }
    );
    update();
  };

  const boot = () => {
    reveal();
    heroStage();
    parallax();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', () => {
    reveal();
    heroStage();
  });
})();
